export const CATEGORIES = [
  'food',
  'transportation',
  'hotel',
  'education',
  'business',
  'entertainment',
  'other',
] as const;
export type Category = (typeof CATEGORIES)[number];

export const CATEGORY_EMOJI: Record<Category, string> = {
  food: '🍔',
  transportation: '🚕',
  hotel: '🏨',
  education: '📚',
  business: '💼',
  entertainment: '🎉',
  other: '🧾',
};

export function isCategory(value: unknown): value is Category {
  return typeof value === 'string' && (CATEGORIES as readonly string[]).includes(value);
}

export const LANGUAGES = ['en', 'km'] as const;
export type Language = (typeof LANGUAGES)[number];
